@import "../../../globalStyles/commons";

:host {
  display: block;
}

slot::slotted(goat-accordion-item) {
  border-top: 1px solid var(--border-subtle);
}

slot::slotted(goat-accordion-item:last-child) {
  border-bottom: 1px solid var(--border-subtle);
}
